/* HANGER — global.js (no dependencies) */
(function () {
  'use strict';

  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));

  /* One passive page-scroll tracker, shared by every component that needs to
     know whether the page is currently moving. Cheaper than each card
     listening for itself, and lets tap handlers ignore momentum-arresting
     taps. */
  let lastScrollAt = 0;
  window.addEventListener('scroll', () => { lastScrollAt = Date.now(); }, { passive: true });

  /* ---------- Drawers (nav + cart) ---------- */
  const overlay = $('.overlay');
  function openDrawer(el) {
    el.classList.add('is-open');
    overlay && overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    const focusable = el.querySelector('button, a, input');
    focusable && focusable.focus();
  }
  function closeDrawers() {
    $$('.nav-drawer.is-open, .cart-drawer.is-open').forEach(d => d.classList.remove('is-open'));
    $$('.nav-drawer__panel.is-active').forEach(p => p.classList.remove('is-active'));
    overlay && overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-open-nav]')) { openDrawer($('.nav-drawer')); }
    if (e.target.closest('[data-open-cart]')) { e.preventDefault(); openDrawer($('.cart-drawer')); }
    if (e.target.closest('[data-close-drawer]') || e.target === overlay) {
      closeDrawers();
      $$('.filter-drawer.is-open, .sort-sheet.is-open').forEach(p => p.classList.remove('is-open'));
      $$('.sheet.is-open').forEach(p => {
        p.classList.remove('is-open');
        setTimeout(() => { if (!p.classList.contains('is-open')) p.hidden = true; }, 360);
      });
    }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- Menu drawer panels ---------- */
  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('[data-nav-open]');
    if (openBtn) {
      const panel = document.querySelector('[data-panel="' + openBtn.dataset.navOpen + '"]');
      panel && panel.classList.add('is-active');
      return;
    }
    const backBtn = e.target.closest('[data-nav-back]');
    if (backBtn) {
      const panel = backBtn.closest('.nav-drawer__panel');
      panel && panel.classList.remove('is-active');
    }
  });

  /* ---------- Cart AJAX ---------- */
  async function cartRequest(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
    if (!res.ok) throw await res.json();
    return res.json();
  }

  async function refreshCartDrawer() {
    const res = await fetch('/?section_id=cart-drawer');
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('.cart-drawer');
    const current = $('.cart-drawer');
    if (fresh && current) {
      const wasOpen = current.classList.contains('is-open');
      current.innerHTML = fresh.innerHTML;
      if (wasOpen) current.classList.add('is-open');
    }
    const cart = await (await fetch('/cart.js')).json();
    $$('[data-cart-count]').forEach(el => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
  }

  // Add to cart (product form)
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const original = btn.textContent;
    btn.disabled = true; btn.textContent = btn.dataset.addingText || '…';
    try {
      await cartRequest('/cart/add.js', {
        items: [{ id: Number(form.querySelector('[name="id"]').value), quantity: 1 }]
      });
      await refreshCartDrawer();
      openDrawer($('.cart-drawer'));
    } catch (err) {
      alert((err && err.description) || 'Could not add to cart.');
    } finally {
      btn.disabled = false; btn.textContent = original;
    }
  });

  // Quantity change / remove in drawer
  document.addEventListener('click', async (e) => {
    const qtyBtn = e.target.closest('[data-qty-change]');
    const removeBtn = e.target.closest('[data-line-remove]');
    if (!qtyBtn && !removeBtn) return;
    e.preventDefault();
    const line = (qtyBtn || removeBtn).closest('[data-line-key]');
    const key = line.dataset.lineKey;
    let quantity = 0;
    if (qtyBtn) {
      const input = line.querySelector('input');
      quantity = Math.max(0, Number(input.value) + Number(qtyBtn.dataset.qtyChange));
    }
    try {
      await cartRequest('/cart/change.js', { id: key, quantity });
      await refreshCartDrawer();
    } catch (err) {
      alert((err && err.description) || 'Could not update cart.');
    }
  });

  /* ---------- Variant picker (PDP) ---------- */
  const pdpForm = $('form[data-product-form][data-variants]');
  if (pdpForm) {
    const variants = JSON.parse(pdpForm.dataset.variants);
    const idInput = pdpForm.querySelector('[name="id"]');

    function selectedOptions() {
      return $$('.option-group', pdpForm.closest('.pdp__info') || document).map(g =>
        (g.querySelector('[aria-pressed="true"]') || {}).dataset ? g.querySelector('[aria-pressed="true"]').dataset.value : null
      );
    }
    function updateVariant() {
      const opts = selectedOptions();
      const match = variants.find(v => v.options.every((o, i) => o === opts[i]));
      const priceEls = $$('.pdp__price[data-price], .buybar [data-price]');
      const btns = $$('form[data-product-form] [type="submit"]');
      if (match) {
        idInput.value = match.id;
        /* Rebuild the full price block, not just the number. Writing
           price_formatted alone wiped the strikethrough and the discount
           badge the moment a customer picked a size on a sale product. */
        const priceHtml = match.compare_at_formatted
          ? '<s>' + match.compare_at_formatted + '</s><em>' + match.price_formatted + '</em>' +
            '<span class="pdp__price-badge">-' + match.discount_pct + '%</span>'
          : match.price_formatted;
        priceEls.forEach(el => { el.innerHTML = priceHtml; });
        btns.forEach(b => {
          b.disabled = !match.available;
          b.textContent = match.available ? b.dataset.addText : b.dataset.soldoutText;
        });
        // Sync hidden buy-bar form
        $$('.buy-bar [name="id"]').forEach(i => i.value = match.id);
        const meta = $('[data-buybar-meta]');
        if (meta) meta.innerHTML = match.price_formatted + (match.title && match.title !== 'Default Title' ? ' · ' + match.title : '');
        if (match.media_id) {
          const rail = $('[data-gallery-rail]');
          if (rail) {
            const imgs = $$('img', rail);
            const idx = imgs.findIndex(im => im.dataset.mediaId === String(match.media_id));
            if (idx > -1) rail.scrollTo({ left: rail.clientWidth * idx, behavior: 'smooth' });
          }
        }
      }
    }
    document.addEventListener('click', (e) => {
      const chip = e.target.closest('.size-chip, .swatch[data-value]');
      if (!chip || !chip.closest('.option-group')) return;
      e.preventDefault();
      $$('.size-chip, .swatch', chip.closest('.option-group')).forEach(c => c.setAttribute('aria-pressed', 'false'));
      chip.setAttribute('aria-pressed', 'true');
      const label = chip.closest('.option-group').querySelector('[data-selected-value]');
      label && (label.textContent = chip.dataset.value);
      updateVariant();
    });
    updateVariant();
  }

  /* ---------- Density toggle ----------
     Only ever touches the grid that the toggle actually controls.

     This used to grab `$('.product-grid')` — the first grid anywhere on the
     page — and stamp the saved density onto it. On the homepage that is the
     featured-collection grid, so a customer who picked 1-up or 3-up on a
     collection page carried that choice onto the homepage, search results
     and the collections list, all of which are meant to be fixed at 2-up.

     Scoping to the toggle's own section fixes it: pages without a toggle
     keep whatever `data-density` their Liquid rendered. */
  const densityToggle = $('.density-toggle');
  if (densityToggle) {
    const scope = densityToggle.closest('.shopify-section') || document;
    const grid = scope.querySelector('.product-grid');
    if (grid) {
      const saved = localStorage.getItem('hanger:density');
      if (saved) grid.dataset.density = saved;
      $$('.density-toggle button').forEach(b => {
        b.setAttribute('aria-pressed', String(b.dataset.density === grid.dataset.density));
        b.addEventListener('click', () => {
          grid.dataset.density = b.dataset.density;
          localStorage.setItem('hanger:density', b.dataset.density);
          $$('.density-toggle button').forEach(x => x.setAttribute('aria-pressed', String(x === b)));
        });
      });
    }
  }

  /* ---------- Product card image rails ---------- */
  function scrollRailTo(rail, index) {
    rail.scrollTo({ left: rail.clientWidth * index, behavior: 'smooth' });
  }
  function railIndex(rail) {
    return rail.clientWidth ? Math.round(rail.scrollLeft / rail.clientWidth) : 0;
  }

  /* ---------- Desktop rail controls ----------
     Touch users swipe. Mouse users have no swipe and the scrollbars are
     hidden, so without these a rail is completely unusable on desktop.
     Everything below is gated behind a fine pointer so touch stays clean. */
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  const CHEV = dir =>
    '<svg width="14" height="14" viewBox="0 0 18 18" fill="none" stroke="currentColor" ' +
    'stroke-width="1.6" aria-hidden="true"><path d="M' + (dir < 0 ? '12 2L5 9l7 7' : '6 2l7 7-7 7') + '"/></svg>';

  function addRailNav(rail, host, variant) {
    if (!finePointer || !rail || !host) return;
    // Deliberately no early "is it scrollable?" bail — at first paint the
    // images may not be laid out yet and scrollWidth would read as equal to
    // clientWidth, silently dropping the arrows. sync() decides instead, and
    // disabled arrows are invisible anyway.
    const nav = document.createElement('div');
    nav.className = 'rail-nav' + (variant === 'gallery' ? ' rail-nav--gallery' : '');

    const prev = document.createElement('button');
    const next = document.createElement('button');
    [prev, next].forEach(b => { b.type = 'button'; b.className = 'rail-nav__btn'; });
    prev.innerHTML = CHEV(-1);
    next.innerHTML = CHEV(1);
    prev.setAttribute('aria-label', 'Previous image');
    next.setAttribute('aria-label', 'Next image');

    function step(dir) {
      // scrollLeft is negative in RTL, so work in absolute terms
      const page = rail.clientWidth || 1;
      const cur = Math.round(Math.abs(rail.scrollLeft) / page);
      scrollRailTo(rail, Math.max(0, cur + dir));
    }
    prev.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); step(-1); });
    next.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); step(1); });

    function sync() {
      const max = rail.scrollWidth - rail.clientWidth - 4;
      const pos = Math.abs(rail.scrollLeft);
      prev.disabled = pos <= 4;
      next.disabled = pos >= max;
    }
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    window.addEventListener('load', sync);   // re-check once images have laid out
    sync();

    nav.appendChild(prev);
    nav.appendChild(next);
    host.appendChild(nav);
  }

  /* Click-and-drag to scroll — what most people instinctively try with a
     mouse. One shared pair of window listeners for the whole page rather
     than a pair per rail, so a page of 24 cards doesn't run 48 handlers on
     every mouse move. */
  let dragRail = null, dragStartX = 0, dragStartScroll = 0, dragMoved = false;

  function addDragScroll(rail) {
    if (!finePointer || !rail) return;
    rail.addEventListener('mousedown', (e) => {
      if (e.button !== 0) return;
      dragRail = rail;
      dragMoved = false;
      dragStartX = e.clientX;
      dragStartScroll = rail.scrollLeft;
    });
  }

  window.addEventListener('mousemove', (e) => {
    if (!dragRail) return;
    const dx = e.clientX - dragStartX;
    if (Math.abs(dx) > 4) {
      if (!dragMoved) { dragMoved = true; dragRail.classList.add('is-dragging'); }
      dragRail.scrollLeft = dragStartScroll - dx;
    }
  });

  window.addEventListener('mouseup', () => {
    if (!dragRail) return;
    const rail = dragRail;
    dragRail = null;
    rail.classList.remove('is-dragging');
    // Swallow the click that fires after a drag so it doesn't open the product
    if (dragMoved) {
      const swallow = (ev) => { ev.preventDefault(); ev.stopPropagation(); };
      rail.addEventListener('click', swallow, { capture: true, once: true });
      setTimeout(() => rail.removeEventListener('click', swallow, { capture: true }), 60);
    }
  });

  $$('[data-card]').forEach(card => {
    const rail = card.querySelector('[data-card-rail]');
    if (!rail) return;
    const dots = card.querySelector('[data-card-dots]');
    const imgs = $$('img', rail);

    if (dots) {
      rail.addEventListener('scroll', () => {
        const i = railIndex(rail);
        $$('i', dots).forEach((d, n) => d.classList.toggle('is-on', n === i));
      }, { passive: true });
    }

    // Tap opens the product, drag scrolls.
    // Deliberately no pointermove listener — it fires continuously while the
    // page scrolls and adds main-thread work to every frame. Comparing the
    // up/down coordinates gives the same answer for free.
    let startX = 0, startY = 0, startT = 0;
    rail.addEventListener('pointerdown', (e) => {
      startX = e.clientX; startY = e.clientY; startT = Date.now();
    }, { passive: true });
    rail.addEventListener('pointerup', (e) => {
      if (!rail.dataset.url) return;
      // Ignore taps that land while the page is still settling from a scroll,
      // otherwise tapping to arrest momentum navigates by mistake.
      if (Date.now() - lastScrollAt < 250) return;
      const movedFar = Math.abs(e.clientX - startX) > 8 || Math.abs(e.clientY - startY) > 8;
      const heldLong = Date.now() - startT > 500;
      if (!movedFar && !heldLong) window.location.href = rail.dataset.url;
    }, { passive: true });
    rail.addEventListener('keydown', (e) => {
      if ((e.key === 'Enter' || e.key === ' ') && rail.dataset.url) { e.preventDefault(); window.location.href = rail.dataset.url; }
      if (e.key === 'ArrowRight') { e.preventDefault(); scrollRailTo(rail, railIndex(rail) + 1); }
      if (e.key === 'ArrowLeft')  { e.preventDefault(); scrollRailTo(rail, Math.max(0, railIndex(rail) - 1)); }
    });

    // Desktop affordances: arrows over the image, plus drag-to-scroll
    if (imgs.length > 1) addRailNav(rail, card, 'card');
    addDragScroll(rail);

    // swatch -> scroll rail to that colour's image
    $$('.swatch-row--card .swatch', card).forEach(sw => {
      sw.addEventListener('click', (e) => {
        e.preventDefault(); e.stopPropagation();
        $$('.swatch-row--card .swatch', card).forEach(s2 => s2.classList.remove('is-active'));
        sw.classList.add('is-active');
        const id = sw.dataset.mediaId;
        if (!id) return;
        const idx = imgs.findIndex(im => im.dataset.mediaId === id);
        if (idx > -1) scrollRailTo(rail, idx);
      });
    });
  });


  /* ---------- Scroll hint (first cards, dismisses on swipe or after 15s) ---------- */
  $$('[data-scroll-hint]').forEach(card => {
    const hint = card.querySelector('[data-hint]');
    const rail = card.querySelector('[data-card-rail]');
    if (!hint) return;
    let done = false;
    const dismiss = () => {
      if (done) return;
      done = true;
      hint.classList.add('is-done');
      setTimeout(() => hint.remove(), 700);
    };
    rail && rail.addEventListener('scroll', dismiss, { passive: true, once: true });
    rail && rail.addEventListener('pointerdown', dismiss, { once: true });
    setTimeout(dismiss, 15000);
  });

  /* ---------- Collection filters + sort ---------- */
  const filterDrawer = $('[data-filter-drawer]');
  const sortSheet = $('[data-sort-sheet]');

  function closePanels() {
    filterDrawer && filterDrawer.classList.remove('is-open');
    sortSheet && sortSheet.classList.remove('is-open');
    overlay && overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  // Named distinctly from openPanel(id) further down — two function
  // declarations sharing a name in one scope silently overwrite each other.
  function openFilterPanel(el) {
    if (!el) return;
    el.classList.add('is-open');
    overlay && overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-open-filters]')) { e.preventDefault(); openFilterPanel(filterDrawer); return; }
    if (e.target.closest('[data-open-sort]'))    { e.preventDefault(); openFilterPanel(sortSheet); return; }
    if (e.target.closest('[data-close-filters]') || e.target.closest('[data-close-sort]')) { closePanels(); return; }

    const sortBtn = e.target.closest('[data-sort-value]');
    if (sortBtn) {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortBtn.dataset.sortValue);
      url.searchParams.delete('page');
      window.location.href = url.toString();
      return;
    }

    if (e.target.closest('[data-apply-filters]')) {
      const form = $('[data-filter-form]');
      if (!form) return;
      const url = new URL(window.location.href);
      // drop existing filter params
      Array.from(url.searchParams.keys())
        .filter(k => k.indexOf('filter.') === 0)
        .forEach(k => url.searchParams.delete(k));
      $$('input', form).forEach(input => {
        if (input.type === 'checkbox') {
          if (input.checked) url.searchParams.append(input.name, input.value);
        } else if (input.value !== '') {
          url.searchParams.set(input.name, input.value);
        }
      });
      url.searchParams.delete('page');
      window.location.href = url.toString();
    }
  });

  /* ---------- Unified panel system (cart · search · wishlist · account · pages) ---------- */
  function panelById(id) { return document.querySelector('[data-panel-id="' + id + '"]'); }

  function openPanel(id) {
    const el = panelById(id);
    if (!el) return null;
    document.body.classList.remove('chat-visible');
    closeAllPanels(true);
    el.hidden = false;
    // force reflow so the transform transition actually runs
    void el.offsetWidth;
    el.classList.add('is-open');
    overlay && overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    return el;
  }

  function closeAllPanels(skipOverlay) {
    $$('.sheet.is-open').forEach(el => {
      el.classList.remove('is-open');
      setTimeout(() => { if (!el.classList.contains('is-open')) el.hidden = true; }, 360);
    });
    if (!skipOverlay) {
      overlay && overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  /* Safety net: if nothing is actually open, the page must be scrollable.
     A stuck `overflow: hidden` on <body> is indistinguishable from a frozen
     page for the customer, so never let it survive a closed state. */
  function releaseScrollIfIdle() {
    const anythingOpen = document.querySelector(
      '.sheet.is-open, .nav-drawer.is-open, .cart-drawer.is-open, .filter-drawer.is-open, .sort-sheet.is-open'
    );
    if (!anythingOpen) document.body.style.overflow = '';
  }
  document.addEventListener('click', () => setTimeout(releaseScrollIfIdle, 400));
  window.addEventListener('pageshow', releaseScrollIfIdle);

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-open-panel]');
    if (trigger) {
      e.preventDefault();
      const id = trigger.dataset.openPanel;
      if (id === 'menu') { openDrawer($('.nav-drawer')); return; }
      if (id === 'cart') { openDrawer($('.cart-drawer')); return; }
      const el = openPanel(id);
      if (id === 'search' && el) {
        const input = el.querySelector('[data-search-input]');
        setTimeout(() => input && input.focus(), 360);
      }
      if (id === 'wishlist') renderWishlist();
      return;
    }
    if (e.target.closest('[data-close-panel]')) { closeAllPanels(); return; }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { closeAllPanels(); document.body.classList.remove('chat-visible'); }
  });

  /* ---------- Shopify Inbox chat, driven from the bottom bar ----------
     Inbox ships a custom element <shopify-chat> whose class is AgentShell.
     Its real API is show() / close(), and `open` is a BOOLEAN PROPERTY, not
     a method — so the old `el.click()` approach could never work. The
     element is also a full-viewport fixed overlay, which is why the CSS
     must never give its host pointer-events. */
  function inboxEl() {
    return document.querySelector(
      'shopify-chat, #shopify-chat, #ShopifyChat, [id^="ShopifyChat"], .shopify-chat-container'
    );
  }

  function openInbox() {
    const el = inboxEl();
    if (!el) return false;
    if (typeof el.show === 'function') { el.show(); return true; }
    if ('open' in el && typeof el.open === 'boolean') { el.open = true; return true; }
    const btn = el.shadowRoot
      ? el.shadowRoot.querySelector('button.activator, button')
      : el.querySelector && el.querySelector('button');
    if (btn) { btn.click(); return true; }
    return false;
  }

  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-open-chat]')) return;
    e.preventDefault();
    closeAllPanels();
    document.body.classList.add('chat-visible');
    // The widget is faded in by CSS; opening on the next frame avoids Safari
    // dropping the call while visibility is still resolving.
    if (openInbox()) return;
    // Inbox loads async — retry briefly rather than failing silently.
    let tries = 0;
    const timer = setInterval(() => {
      if (openInbox() || ++tries > 20) clearInterval(timer);
    }, 150);
  });

  /* ---------- Predictive search ---------- */
  const searchInput = $('[data-search-input]');
  const searchResults = $('[data-search-results]');
  if (searchInput && searchResults) {
    let t = null;
    searchInput.addEventListener('input', () => {
      clearTimeout(t);
      const q = searchInput.value.trim();
      if (q.length < 2) { searchResults.innerHTML = ''; return; }
      t = setTimeout(async () => {
        try {
          const res = await fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8');
          const data = await res.json();
          const items = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!items.length) {
            searchResults.innerHTML = '<p class="search-empty">' + (searchResults.dataset.empty || 'No matches.') + '</p>';
            return;
          }
          searchResults.innerHTML = items.map(p => {
            const img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '" alt="" loading="lazy">' : '';
            return '<a class="search-result" href="' + p.url + '">' + img +
              '<span><span class="search-result__t">' + p.title + '</span><br>' +
              '<span class="search-result__p">' + (p.price || '') + '</span></span></a>';
          }).join('');
        } catch (err) { searchResults.innerHTML = ''; }
      }, 220);
    });
  }

  /* ---------- Wishlist (localStorage) ---------- */
  const WKEY = 'hanger:wishlist';
  function wishGet() {
    try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (e) { return []; }
  }
  function wishSet(list) {
    localStorage.setItem(WKEY, JSON.stringify(list));
    const n = list.length;
    $$('[data-wish-count]').forEach(el => { el.textContent = n; el.hidden = n === 0; });
    $$('[data-wish-toggle]').forEach(btn => {
      btn.classList.toggle('is-on', list.some(i => i.url === btn.dataset.url));
    });
  }
  function wishToggle(item) {
    const list = wishGet();
    const i = list.findIndex(x => x.url === item.url);
    if (i > -1) list.splice(i, 1); else list.unshift(item);
    wishSet(list);
    return i === -1;
  }
  function renderWishlist() {
    const body = $('[data-wishlist-body]');
    if (!body) return;
    const list = wishGet();
    if (!list.length) {
      body.innerHTML = '<div class="empty-state"><p class="text-muted">' + (body.dataset.empty || 'Nothing saved yet.') + '</p></div>';
      return;
    }
    body.innerHTML = list.map(i =>
      '<div class="wish-row">' +
        '<a href="' + i.url + '">' + (i.image ? '<img src="' + i.image + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div><a href="' + i.url + '"><span class="wish-row__t">' + i.title + '</span></a>' +
        '<p class="wish-row__p">' + (i.price || '') + '</p></div>' +
        '<button type="button" class="wish-row__x" data-wish-remove="' + i.url + '">✕</button>' +
      '</div>'
    ).join('');
  }
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-wish-toggle]');
    if (toggle) {
      e.preventDefault(); e.stopPropagation();
      wishToggle({
        url: toggle.dataset.url,
        title: toggle.dataset.title,
        price: toggle.dataset.wishPrice,
        image: toggle.dataset.image
      });
      renderWishlist();
      return;
    }
    const rm = e.target.closest('[data-wish-remove]');
    if (rm) {
      wishSet(wishGet().filter(x => x.url !== rm.dataset.wishRemove));
      renderWishlist();
    }
  });
  wishSet(wishGet());

  /* ---------- Footer content pages as sliding sheets ---------- */
  const pageSheet = panelById('page');
  if (pageSheet) {
    const pTitle = $('[data-page-title]', pageSheet);
    const pBody = $('[data-page-body]', pageSheet);

    function frameMode(url) {
      // Interactive pages (returns portal, forms, embedded apps) load in a
      // same-origin iframe so their scripts run normally — no new tab, no
      // dead copy of the markup.
      pBody.innerHTML = '';
      const frame = document.createElement('iframe');
      frame.className = 'sheet__frame';
      frame.setAttribute('title', pTitle.textContent || '');
      frame.src = url;
      frame.addEventListener('load', () => {
        try {
          const d = frame.contentDocument;
          if (!d) return;
          // Strip the theme chrome inside the frame so it reads as a panel.
          const st = d.createElement('style');
          st.textContent =
            '.site-header,.site-footer,.app-nav,.announcement,.collection-strip,' +
            '.sheet,.overlay,.cart-drawer,.nav-drawer,.buybar{display:none !important}' +
            'body{padding:0 !important;background:transparent !important}' +
            'main,.page-narrow{padding-block:0 !important;margin:0 !important;max-inline-size:none !important}';
          d.head.appendChild(st);
          const h1 = d.querySelector('h1');
          if (h1 && h1.textContent.trim()) {
            pTitle.textContent = h1.textContent.trim();
            h1.style.display = 'none';
          }
        } catch (err) { /* nothing to do if the frame is not readable */ }
      });
      pBody.appendChild(frame);
    }

    document.addEventListener('click', async (e) => {
      const link = e.target.closest('.site-footer a[data-popup]');
      if (!link) return;
      const href = link.getAttribute('href') || '';

      // Only checkout and cart genuinely need a full page load.
      const blocked = ['/cart', '/checkout', '/challenge'];
      let inPanel = href.charAt(0) === '/' && !blocked.some(b => href.indexOf(b) === 0);
      if (link.hasAttribute('data-no-popup')) inPanel = false;
      if (!inPanel) return;
      e.preventDefault();

      pTitle.textContent = link.textContent.trim();
      pBody.innerHTML = '';
      pBody.classList.remove('sheet__body--frame');
      openPanel('page');

      // Anything that is clearly an application route goes straight to iframe.
      const appRoute = ['/account', '/apps/', '/a/', '/tools/'].some(b => href.indexOf(b) === 0);
      if (appRoute || link.hasAttribute('data-frame')) {
        pBody.classList.add('sheet__body--frame');
        frameMode(href);
        return;
      }

      try {
        const res = await fetch(href);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const content =
          doc.querySelector('.page-narrow .rte') ||
          doc.querySelector('.product-grid') ||
          doc.querySelector('.rte') ||
          doc.querySelector('main');

        // If the page needs JavaScript to work, switch to iframe rather than
        // injecting inert markup.
        const interactive = !content ||
          content.querySelector('script, iframe, form, [data-app], [id*="return"], [class*="return"]');
        if (interactive) {
          pBody.classList.add('sheet__body--frame');
          frameMode(href);
          return;
        }

        pBody.innerHTML = content.innerHTML;
        const h = doc.querySelector('.page-narrow h1') || doc.querySelector('.collection-head h1');
        if (h) pTitle.textContent = h.textContent.trim();
        if (content.classList.contains('product-grid')) {
          const more = document.createElement('a');
          more.className = 'btn btn--ghost btn--full';
          more.style.marginBlockStart = '18px';
          more.href = href;
          more.textContent = pTitle.textContent;
          pBody.appendChild(more);
        }
      } catch (err) {
        pBody.classList.add('sheet__body--frame');
        frameMode(href);
      }
    });
  }

  /* ---------- PDP gallery dots + desktop controls ---------- */
  const gallery = $('[data-gallery-rail]');
  const dots = $('[data-gallery-dots]');
  if (gallery && dots) {
    gallery.addEventListener('scroll', () => {
      const idx = gallery.clientWidth ? Math.round(Math.abs(gallery.scrollLeft) / gallery.clientWidth) : 0;
      $$('i', dots).forEach((d, i) => d.classList.toggle('on', i === idx));
    }, { passive: true });
  }
  if (gallery) {
    addRailNav(gallery, gallery.closest('.gal'), 'gallery');
    addDragScroll(gallery);
    gallery.setAttribute('tabindex', '0');
    gallery.addEventListener('keydown', (e) => {
      const i = railIndex(gallery);
      if (e.key === 'ArrowRight') { e.preventDefault(); scrollRailTo(gallery, i + 1); }
      if (e.key === 'ArrowLeft')  { e.preventDefault(); scrollRailTo(gallery, Math.max(0, i - 1)); }
    });
  }

  /* ---------- Collection strip: mouse drag + vertical wheel → horizontal ----------
     The strip sits under a sticky header with no room for arrows, so give it
     the two things a mouse user will actually reach for. */
  const strip = $('.collection-strip');
  if (strip && finePointer) {
    addDragScroll(strip);
    strip.addEventListener('wheel', (e) => {
      // Only hijack a purely vertical wheel; leave trackpad h-scroll alone
      if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
      const max = strip.scrollWidth - strip.clientWidth;
      if (max <= 0) return;
      e.preventDefault();
      strip.scrollLeft += e.deltaY;
    }, { passive: false });
  }

  /* ---------- Content sheet (footer links) ---------- */
  const sheet = $('[data-sheet]');
  if (sheet) {
    const body = $('[data-sheet-body]', sheet);
    const titleEl = $('[data-sheet-title]', sheet);
    let lastFocus = null;

    function openSheet() {
      sheet.hidden = false;
      requestAnimationFrame(() => sheet.classList.add('is-open'));
      document.body.style.overflow = 'hidden';
      const close = $('[data-sheet-close]', sheet);
      close && close.focus();
    }
    function closeSheet() {
      sheet.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(() => { sheet.hidden = true; }, 280);
      lastFocus && lastFocus.focus();
    }

    document.addEventListener('click', async (e) => {
      const link = e.target.closest('[data-sheet-link]');
      if (link) {
        const url = link.getAttribute('href');
        if (!url || url === '#' || /^(https?:)?\/\//i.test(url) && !url.includes(location.host)) return;
        e.preventDefault();
        lastFocus = link;
        titleEl.textContent = link.textContent.trim();
        body.innerHTML = '<p class="text-muted">' + (body.dataset.loading || 'Loading…') + '</p>';
        openSheet();
        try {
          const res = await fetch(url);
          if (!res.ok) throw new Error('fetch failed');
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          const content = doc.querySelector('.page-narrow .rte') || doc.querySelector('.rte') || doc.querySelector('main');
          const heading = doc.querySelector('main h1');
          if (heading) titleEl.textContent = heading.textContent.trim();
          body.innerHTML = content ? content.innerHTML : '<p>' + url + '</p>';
        } catch (err) {
          window.location.href = url;
        }
        return;
      }
      if (e.target.closest('[data-sheet-close]') || e.target === sheet) closeSheet();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && sheet.classList.contains('is-open')) closeSheet();
    });
  }
})();